/**
 * 宅吉 · 站点语言（CN / EN，可扩展）
 * localStorage + ?lang= 同步
 */
(function (global) {
  var STORAGE_KEY = 'zhaiji-locale';
  var DEFAULT = 'zh';
  var SUPPORTED = ['zh', 'en'];

  function normalize(loc) {
    var s = String(loc || '').toLowerCase().replace('_', '-');
    if (s.indexOf('en') === 0) return 'en';
    if (s.indexOf('zh') === 0) return 'zh';
    return SUPPORTED.indexOf(s) >= 0 ? s : DEFAULT;
  }

  function fromUrl() {
    try {
      var q = new URLSearchParams(global.location.search).get('lang');
      if (q) return normalize(q);
    } catch (e) { /* ignore */ }
    return null;
  }

  function fromStorage() {
    try {
      var s = global.localStorage.getItem(STORAGE_KEY);
      if (s) return normalize(s);
    } catch (e) { /* ignore */ }
    return null;
  }

  /** Shopify 商城语言（与抽屉里的 EN/ZH 选择同步） */
  function fromShopifyLocale() {
    try {
      var h = global.location.hostname || '';
      if (h !== 'shop.zhaiji.net' && !h.endsWith('.myshopify.com')) return null;
      if (global.__ZHAIJI_SHOPIFY_LOCALE__) {
        return normalize(global.__ZHAIJI_SHOPIFY_LOCALE__);
      }
      var path = currentPathname();
      if (path === '/en' || path.indexOf('/en/') === 0) return 'en';
      if (/^\/zh(-cn|-tw|-hans)?(\/|$)/i.test(path)) return 'zh';
    } catch (e) { /* ignore */ }
    return null;
  }

  function get() {
    return fromUrl() || fromShopifyLocale() || fromStorage() || DEFAULT;
  }

  function currentPathname() {
    try {
      var p = global.location.pathname || '/';
      if (p.length > 1 && p.charAt(p.length - 1) === '/') {
        p = p.slice(0, -1);
      }
      return p;
    } catch (e) {
      return '/';
    }
  }

  function isChineseHome(path) {
    return path === '/' || path === '/index.html';
  }

  function isEnglishHome(path) {
    return path === '/index-en.html';
  }

  function isHomepage(path) {
    path = path || currentPathname();
    return isChineseHome(path) || isEnglishHome(path);
  }

  /** 首页为独立 HTML（index / index-en），需按语言跳转 */
  function homepageRedirectUrl(locale) {
    locale = normalize(locale);
    try {
      var path = currentPathname();
      if (!isHomepage(path)) return null;
      var targetPath = locale === 'en' ? '/index-en.html' : '/';
      if (locale === 'en' && isEnglishHome(path)) return null;
      if (locale !== 'en' && isChineseHome(path)) return null;
      var url = new URL(targetPath, global.location.origin);
      url.searchParams.set('lang', locale);
      if (global.location.hash) url.hash = global.location.hash;
      return url.toString();
    } catch (e) {
      return null;
    }
  }

  /** 文章列表/单篇为独立中英文 HTML（与 article-locale-bar.js 路径配对一致） */
  function articleLocalePair(path) {
    path = path || currentPathname();
    if (path === '/articles' || path === '/articles/index.html') {
      return { zh: '/articles/', en: '/articles/index-en.html', locale: 'zh' };
    }
    if (path === '/articles/index-en.html') {
      return { zh: '/articles/', en: '/articles/index-en.html', locale: 'en' };
    }
    var enMatch = path.match(/^\/articles\/en\/(\d{2}-\w+\.html)$/);
    if (enMatch) {
      return {
        zh: '/articles/' + enMatch[1],
        en: path,
        locale: 'en',
      };
    }
    var zhMatch = path.match(/^\/articles\/(\d{2}-\w+\.html)$/);
    if (zhMatch) {
      return {
        zh: path,
        en: '/articles/en/' + zhMatch[1],
        locale: 'zh',
      };
    }
    return null;
  }

  function articleRedirectUrl(locale) {
    locale = normalize(locale);
    try {
      var pair = articleLocalePair();
      if (!pair || pair.locale === locale) return null;
      var targetPath = locale === 'en' ? pair.en : pair.zh;
      var url = new URL(targetPath, global.location.origin);
      url.searchParams.set('lang', locale);
      if (global.location.hash) url.hash = global.location.hash;
      return url.toString();
    } catch (e) {
      return null;
    }
  }

  function localeSplitPageRedirectUrl(locale) {
    return homepageRedirectUrl(locale) || articleRedirectUrl(locale);
  }

  function maybeRedirectSplitPage(locale) {
    var href = localeSplitPageRedirectUrl(locale);
    if (href) {
      global.location.replace(href);
      return true;
    }
    return false;
  }

  function maybeRedirectHomepage(locale) {
    return maybeRedirectSplitPage(locale);
  }

  function applyDocumentLang(locale) {
    locale = normalize(locale);
    if (global.document && global.document.documentElement) {
      global.document.documentElement.lang = locale === 'en' ? 'en' : 'zh-Hans';
      global.document.documentElement.classList.toggle('zhaiji-locale-en', locale === 'en');
    }
    ensureLocaleStyles(locale);
  }

  function ensureLocaleStyles(locale) {
    locale = normalize(locale);
    if (!global.document || !global.document.head) return;
    var id = 'zhaiji-locale-en-css';
    var link = global.document.getElementById(id);
    if (locale === 'en') {
      if (!link) {
        link = global.document.createElement('link');
        link.id = id;
        link.rel = 'stylesheet';
        link.href = '/css/locale-en.css?v=20260534';
        global.document.head.appendChild(link);
      }
    } else if (link && link.parentNode) {
      link.parentNode.removeChild(link);
    }
  }

  /**
   * @param {string} locale
   * @param {{ reload?: boolean }} opts — 默认 reload 以刷新整页文案
   */
  function set(locale, opts) {
    opts = opts || {};
    locale = normalize(locale);
    try {
      global.localStorage.setItem(STORAGE_KEY, locale);
    } catch (e) { /* ignore */ }
    applyDocumentLang(locale);
    if (opts.reload !== false) {
      if (maybeRedirectHomepage(locale)) return locale;
      try {
        var url = new URL(global.location.href);
        url.searchParams.set('lang', locale);
        global.location.replace(url.toString());
        return locale;
      } catch (e2) { /* fall through */ }
    }
    try {
      global.dispatchEvent(new CustomEvent('zhaiji-locale-change', { detail: { locale: locale } }));
    } catch (e3) { /* ignore */ }
    return locale;
  }

  function withLang(href, locale) {
    locale = normalize(locale || get());
    try {
      var base = global.location.origin;
      var u = new URL(href, base);
      u.searchParams.set('lang', locale);
      // 外链（如 shop.zhaiji.net）须保留完整 URL，不可只返回 pathname
      if (/^https?:\/\//i.test(href) || u.origin !== base) {
        return u.toString();
      }
      return u.pathname + u.search + u.hash;
    } catch (e) {
      return href;
    }
  }

  function init() {
    var shopLoc = fromShopifyLocale();
    var locale = fromUrl() || shopLoc || fromStorage() || DEFAULT;
    if (shopLoc) {
      try {
        global.localStorage.setItem(STORAGE_KEY, shopLoc);
      } catch (e) { /* ignore */ }
    }
    applyDocumentLang(locale);
    maybeRedirectHomepage(locale);
  }

  global.ZhaijiLocale = {
    get: get,
    set: set,
    normalize: normalize,
    withLang: withLang,
    init: init,
    isHomepage: isHomepage,
    homepageRedirectUrl: homepageRedirectUrl,
    articleLocalePair: articleLocalePair,
    articleRedirectUrl: articleRedirectUrl,
    localeSplitPageRedirectUrl: localeSplitPageRedirectUrl,
    fromShopifyLocale: fromShopifyLocale,
    SUPPORTED: SUPPORTED,
    DEFAULT: DEFAULT,
    STORAGE_KEY: STORAGE_KEY,
  };

  init();
})(typeof window !== 'undefined' ? window : global);
